import { forwardRef } from 'react'
import { Box, Body, Icon, Close } from '../'
import './Card.scss'

export const Card = forwardRef(function Card({
  title, titleIcon, background, textColor, selected, shadow = true, border = true,
  className, children, onClick, onClose, ...props }, ref) {
  return (
    <Box
      className={'card' + (shadow ? ' shadow' : '') + (selected ? ' selected' : '') + (className ? ` ${className}` : '')}
      background={background}
      color={textColor}
      justifyContent="center"
      alignItems="center"
      cursor={onClick && 'pointer'}
      onClick={onClick}
      border={(!border && !selected) && 'none'}
      ref={ref}
      {...props}
    >
      {(title || titleIcon) &&
        <Box justifyContent="center" alignItems="center">
          {titleIcon &&
            <Icon icon={titleIcon} fill={textColor}/>
          }
          {title &&
            <Body bold>{title}</Body>
          }
        </Box>
      }
      {onClose &&
        <Box
          position="absolute"
          top={0}
          right={0}
          onClick={onClose}
          p={16}
          cursor="pointer"
        >
          <Close fill={textColor}/>
        </Box>
      }
      {children}
    </Box>
  )
})